// This file is automatically generated from ingestAssets.mjs
import * as React from 'react';
import IconContainer, { IconProps } from '../../../components/IconContainer';

export function GraduationCapBoldIcon(props: IconProps) {
	return (
		<IconContainer {...props}>
			{
				<svg
					xmlns="http://www.w3.org/2000/svg"
					width="100%"
					height="100%"
					fill="none"
					viewBox="0 0 32 32"
				>
					<path
						fill="currentColor"
						d="m31.225 10.686-14.5-8a1.5 1.5 0 0 0-1.45 0l-14.5 8a1.5 1.5 0 0 0 0 2.625l2.725 1.5v5.97a2.486 2.486 0 0 0 .636 1.665C5.83 24.337 9.625 27.5 16 27.5a17.11 17.11 0 0 0 5-.719V30a1.5 1.5 0 1 0 3 0v-4.485a14.942 14.942 0 0 0 3.864-3.064c.41-.457.637-1.05.636-1.665v-5.97l2.725-1.5a1.5 1.5 0 0 0 0-2.625v-.005ZM16 5.714 27.395 12l-4.145 2.287a.244.244 0 0 1-.023-.014l-6.5-3.587a1.5 1.5 0 0 0-1.45 2.625l4.876 2.687L16 18.288 4.605 12 16 5.714ZM16 24.5c-5.053 0-8.081-2.384-9.5-3.909v-4.125l8.775 4.843a1.5 1.5 0 0 0 1.45 0L21 18.955v4.654a13.808 13.808 0 0 1-5 .891Zm9.5-3.909c-.46.493-.962.945-1.5 1.351V17.3l1.5-.828v4.12Z"
					/>
				</svg>
			}
		</IconContainer>
	);
}
